<div class="page">

  <div class="pagehead">
    <div>
      <h1>Marketing media</h1>
      <p>Posters and creatives for your counter — share on WhatsApp or download to print</p>
    </div>
  </div>

  <div class="media-grid" *ngIf="getRetailerNotificationsdata && getRetailerNotificationsdata.length; else noMedia">
    <div class="card card--hover media" *ngFor="let i of getRetailerNotificationsdata">
      <img class="media-img" [src]="i.previewattachurl" alt="Marketing creative"
        (click)="seeImage(i.previewattachurl,mymodal,i.attachurl)">
      <div class="media-actions">
        <share-button button="whatsapp" [url]="i.attachurl" [title]="'Marketing Media'"
          [description]="'Marketing Media PDF'"></share-button>
        <a class="media-dl" [href]="i.attachurl" target="_blank" download title="Download file">
          <i class="fa fa-download" aria-hidden="true"></i>
        </a>
      </div>
    </div>
  </div>
  <ng-template #noMedia>
    <div class="card page-empty">
      <span class="t">No media right now</span>
      New creatives appear here as the marketing team publishes them.
    </div>
  </ng-template>

</div>

<ng-template #mymodal let-modal>
  <div class="modal-header er-modal-head">
    <h4 class="modal-title" id="modal-basic-title">Print media</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <img [src]="modalImage" class="modal-img" alt="Marketing creative preview">
    <div class="modal-media-actions">
      <share-buttons title="Share on WhatsApp" [include]="['whatsapp']" [showText]="true"
        url="{{attachurl}}" [title]="'Marketing media'"></share-buttons>
      <a class="media-dl" [href]="attachurl" target="_blank" download title="Download file">
        <i class="fa fa-download" aria-hidden="true"></i>
      </a>
    </div>
  </div>
</ng-template>
